/**
 * Standalone entry for KHERD-Client — the limited, public feedback bar on a client's
 * STAGING site. Enqueued by the WordPress plugin on *.pilotpractice.cloud hosts only,
 * never on a live domain (Roy, 2026-10-22, task 182083).
 */
import { initClientFeedback } from './js/modules/feedback/client';

initClientFeedback();
